import { Grid, Typography, Box } from "@mui/material";
import CasenoIcon from "../../../../assets/SvgIcons/icons-caseno.svg";
import CustomBox from "../Common/CustomBox";
import Card from "../Common/Card";
import FAQ from "../Common/FAQ";
import useCustomLogic from "../../../../Hooks/UseCustomLogic";
import LitigantBox from "../Common/LitigantBox";
import { useState, useEffect } from "react";
import ProgressBarTempo from "../Common/ProgressBarTempo";
import ProgressBarComponent from "../../../../components/ReusableComponents/ProgressBarComponent";
import { LoaderComponent } from "../../../../components/Loader/LoaderComponent";
import { BlockGridGraph } from "../BuildingBetterCourtsData";

const cardDataStatic = [
  {
    icon: CasenoIcon,
    content: "Case No.",
    statistics: "50%",
  },
];

const faqsStatic = [
  {
    content: "Is there an e-case display board inside waiting area?",
    status: "No",
  },
  { content: "Is there an e-case display board at the entry?", status: "No" },
];

const progressBarDataStatic = [
  {
    content: "Announcement",
    Percentage: "47",
  },
  {
    content: "Lawyer",
    Percentage: "22",
  },
  {
    content: "eCase Display",
    Percentage: "0",
  },
  {
    content: "Court Staff",
    Percentage: "28",
  },
  {
    content: "Companion",
    Percentage: "28",
  },
];

export const CaseDisplay = ({ dataState, dataDistrict, selectedDistrict }) => {
  const { theme, loader } = useCustomLogic();
  let isDistrict = selectedDistrict == "Select District";
  const [cardData, setCardData] = useState(cardDataStatic);
  const [faqs, setFaqs] = useState(faqsStatic);
  const [progressBarData, setProgressBarData] = useState(progressBarDataStatic);

  useEffect(() => {
    if (dataState) {
      let arr = [dataState?.case_no ?? 0];
      setCardData(
        cardData.map((item, index) => ({
          ...item,
          statistics: `${arr[index]}%`,
        }))
      );

      let arr2 = [
        dataState?.announcement,
        dataState?.lawyer,
        dataState?.ecase,
        dataState?.staff,
        dataState?.companion,
      ];
      setProgressBarData(
        progressBarData.map((item, index) => ({
          ...item,
          Percentage: arr2[index],
        }))
      );
    }
    if (dataDistrict) {
      let arr = [
        dataDistrict?.tv_screen_case_display ?? "",
        dataDistrict?.electronic_case_display ?? "",
      ];
      setFaqs(faqs.map((item, index) => ({ ...item, status: arr[index] })));
      let arr2 = [
        dataDistrict?.announcement_of_number_by_announcement ?? dataDistrict?.announcement,
        dataDistrict?.announcement_of_number_by_lawyerInformed ?? dataDistrict?.lawyer,
        dataDistrict?.announcement_of_number_by_tokenDisplay ?? dataDistrict?.ecase,
        dataDistrict?.announcement_of_number_by_staffInformed ?? dataDistrict?.staff,
        dataDistrict?.announcement_of_number_by_friendInformed ?? dataDistrict?.companion,
      ];
      if (!isDistrict) {
        setProgressBarData((prev) =>
          prev.map((item, index) => ({
            ...item,
            Percentage: arr2[index],
          }))
        );
      }
    }
  }, [dataState, dataDistrict, selectedDistrict]);

  return (
    <>
      {loader ? (
        <LoaderComponent height="50vh" />
      ) : (
        <Box>
          {isDistrict && (
            <>
              <Typography variant="regular3" color="secondary.main">
                How are litigants notified of their cases?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mt: "10px",
                  textAlign: "left",
                  letterSpacing: "0.2px",
                  wordSpacing: "1px",
                }}
              >
                Electronic displays of court and case numbers in the main building and in the
                waiting area of the court complex inform litigants and lawyers about ongoing cases.
                Litigants were asked how they were notified of their case.
              </Typography>
            </>
          )}
          <CustomBox
            content={
              isDistrict ? "AVAILABILITY OF E-CASE DISPLAY" : "Do courts have e-case display board?"
            }
            style={{
              fontSize: !isDistrict && "24px",
              padding: !isDistrict && "8px 13px",
              color: !isDistrict && theme.palette.common.black,
              backgroundColor: !isDistrict && "#e6ebf4",
            }}
          />
          {isDistrict ? (
            <Grid container spacing={3} sx={{ padding: "0px", marginBottom: "20px" }}>
              {cardData &&
                cardData.map((item, index) => {
                  return (
                    <Grid item xs={12} md={6} lg={6} key={index}>
                      <BlockGridGraph percentage={item?.statistics} color="#F25E5E" />
                      <Card
                        content={item.content}
                        imgSrc={item.icon}
                        statistics={item.statistics}
                      />
                    </Grid>
                  );
                })}
            </Grid>
          ) : (
            faqs &&
            faqs.map((elem, index) => {
              return (
                <FAQ
                  content={elem?.content}
                  status={elem?.status}
                  isLastItem={index === faqs.length - 1}
                />
              );
            })
          )}

          <LitigantBox mt={!isDistrict && "26px"} mb={!isDistrict && "0px"} />

          <CustomBox
            mt={!isDistrict && "0px"}
            mb="20px"
            content="HOW DID LITIGANTS KNOW WHEN THEIR CASE WAS BEING CALLED OUT?"
          />
          <div className="progress-bar-container">
            {progressBarData.map((item) => (
              <Grid container>
                <Grid item md={10} xs={12} sm={12} lg={8}>
                  <ProgressBarComponent Percentage={item.Percentage} />
                </Grid>
                <Grid item md={2} xs={12} sm={12} lg={4}>
                  <Typography sx={{ margin: "9px 7px" }}>{item.content}</Typography>
                </Grid>
              </Grid>
            ))}
          </div>
        </Box>
      )}
    </>
  );
};
